export default __webpack_public_path__ + "static/media/salas.85bc3a61.png";